import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import {
  getLeadStatuses,
  changeLeadStage,
  addLeadNote,
  getLeadTimeline,
} from "../../Services/engagementService";

const waLink = (mobile, text) =>
  `https://wa.me/${String(mobile || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

const AdminLeadEngagement = ({ lprId, mobile, currentStatusId, name }) => {
  const [statuses, setStatuses] = useState([]);
  const [stageId, setStageId] = useState(currentStatusId || null);
  const [timeline, setTimeline] = useState([]);
  const [note, setNote] = useState("");

  const reload = useCallback(() => {
    if (!lprId) return;
    getLeadTimeline(lprId).then((d) => setTimeline(d || [])).catch(() => {});
  }, [lprId]);

  useEffect(() => {
    getLeadStatuses().then((s) => setStatuses(s || [])).catch(() => {});
  }, []);
  useEffect(() => setStageId(currentStatusId || null), [currentStatusId]);
  useEffect(() => reload(), [reload]);

  const onStage = async (e) => {
    const id = Number(e.target.value);
    setStageId(id);
    try {
      await changeLeadStage(lprId, id);
      toast.success("Stage updated");
      reload();
    } catch {
      toast.error("Could not update stage");
    }
  };

  const onNote = async () => {
    if (!note.trim()) return;
    try {
      await addLeadNote(lprId, note, "note");
      setNote("");
      reload();
    } catch {
      toast.error("Could not save note");
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-3">
        <div>
          <label className="text-xs text-gray-400 uppercase">Lead stage</label>
          <select
            value={stageId || ""}
            onChange={onStage}
            className="mt-1 w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
          >
            <option value="" disabled>Select stage</option>
            {statuses.map((s) => (
              <option key={s.id} value={s.id}>{s.title}</option>
            ))}
          </select>
        </div>
        <div className="flex gap-2">
          <a
            href={waLink(mobile, `Hi ${name || ""}, `)}
            target="_blank"
            rel="noreferrer"
            onClick={() => addLeadNote(lprId, "Opened WhatsApp", "whatsapp").then(reload).catch(() => {})}
            className="flex-1 text-center bg-[#25D366]/10 text-[#128C7E] rounded-lg py-2 text-sm font-medium"
          >
            WhatsApp
          </a>
          <a
            href={`tel:${mobile}`}
            onClick={() => addLeadNote(lprId, "Called lead", "call").then(reload).catch(() => {})}
            className="flex-1 text-center bg-[#425F80]/10 text-[#425F80] rounded-lg py-2 text-sm font-medium"
          >
            Call
          </a>
        </div>
        <div className="flex gap-2">
          <input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note…"
            className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm"
          />
          <button onClick={onNote} className="bg-[#425F80] text-white rounded-lg px-4 text-sm">Add</button>
        </div>
      </div>

      <div>
        <label className="text-xs text-gray-400 uppercase">Activity</label>
        <div className="mt-1 max-h-64 overflow-y-auto space-y-2 border border-gray-100 rounded-lg p-3">
          {timeline.length === 0 ? (
            <p className="text-sm text-gray-400">No activity yet.</p>
          ) : (
            timeline.map((a) => (
              <div key={a.id} className="text-sm">
                <p className="text-gray-700">
                  {a.type === "status_change" ? "Stage changed" : a.note || a.type}
                </p>
                <p className="text-xs text-gray-400">{moment(a.created_at).fromNow()}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLeadEngagement;
